import { ProgressSpinner } from "primereact/progressspinner";
import React, { Suspense, useContext } from "react";
import { useLazyLoadQuery } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { type reportsScreen_Query } from "@relay/reportsScreen_Query.graphql";
import { ReportsTable } from "./parts/reports-table";
import { ReportsTableFilters } from "./parts/reports-table-filters";
import { ReportsContext, ReportsContextProvider } from "./reports.context";
import { QUERY, reportsPerPage } from "./reports.graphql";
import { BaseScreen } from "../../components/base-screen";
import { NoAccess } from "../../components/no-access";
import { useHasPermissions } from "../../hooks/use-has-permissions";

export const ReportsScreen = () => {
	const { t } = useTranslation("common");
	const { filters } = useContext(ReportsContext);
	const reports = useLazyLoadQuery<reportsScreen_Query>(
		QUERY,
		{
			numItemsPerPage: reportsPerPage,
			filterByReferenceNumberOpt: filters.filterByReferenceNumberOpt,
		},
		{ fetchPolicy: "network-only" },
	);

	const canRead = useHasPermissions(["UserInAccountPermission_ReportAdmin_Read"]);

	const canModify = useHasPermissions(["UserInAccountPermission_ReportAdmin_Modify"]);

	if (!canRead) return <NoAccess />;
	return (
		<BaseScreen title={t("reports.title")}>
			<Suspense fallback={<ProgressSpinner />}>
				<ReportsContextProvider>
					<ReportsTableFilters />
					<ReportsTable
						reportsFragmentRef={reports}
						canModifyReports={canModify}
						canRead={canRead}
					/>
				</ReportsContextProvider>
			</Suspense>
		</BaseScreen>
	);
};
